export default __webpack_public_path__ + "static/icon-tallas-88052617ba5b39a005952353c51e0293.svg";